import React from "react";
import { Link, Location } from "react-router";

import { EventDataLayer, tracking } from "../../app/services/tracking";

type AProps = Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, "href"> & {
  blankLabel?: string;
  dataLayer?: EventDataLayer;
  href: Partial<Location> | string;
  state?: { preventScrollReset: boolean };
};

export const A = React.forwardRef(
  (props: AProps, ref?: React.ForwardedRef<HTMLAnchorElement>) => {
    const {
      "aria-label": ariaLabel,
      blankLabel = "Nouvelle fenêtre",
      children,
      dataLayer,
      href,
      state,
      onClick,
      ...restProps
    } = props;

    const onClickHandler = (
      event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    ) => {
      onClick?.(event);

      if (dataLayer) {
        tracking.trackEvent(dataLayer);
      }
    };

    if (typeof href === "string") {
      if (href.startsWith("http")) {
        return (
          <a
            ref={ref}
            {...restProps}
            aria-label={ariaLabel ? `${ariaLabel} - ${blankLabel}` : blankLabel}
            href={href}
            rel="noreferrer"
            target="_blank"
            onClick={onClickHandler}
          >
            {children}
          </a>
        );
      }

      if (href.startsWith("mailto:") || href.startsWith("tel:")) {
        return (
          <a
            ref={ref}
            {...restProps}
            aria-label={ariaLabel}
            href={href}
            onClick={onClickHandler}
          >
            {children}
          </a>
        );
      }
    }

    return (
      <Link
        ref={ref}
        {...restProps}
        aria-label={ariaLabel}
        state={state}
        to={href}
        onClick={onClickHandler}
      >
        {children}
      </Link>
    );
  },
);
